import { httpPost } from './http'
import {
  toEntityActionsWireBody,
  type IEntityActionsPayload,
} from '~/cynqueModules/entityActions'

/**
 * The transactional write: `POST /api/transactions`.
 *
 * Every actions payload goes here — signing a contract (contract, order,
 * orderMasterService, orderMSService), completing order services (company
 * services and their groups), and the msService options edit. Each action
 * names its own `entity`, so one route serves them all.
 *
 * The server implements it (cynque-api-server #1595, renamed from
 * `/api/actions` by #1627 phase A) and answers **200**, not 201 — nothing reads
 * the code, since `httpPost` returns `responseBody.data` for either. Which
 * entities it accepts is the server's `TRANSACTION_REGISTRY`, mirrored by
 * `api/msw/modules/entityActionsRegistry.ts`; an unregistered one is a 422.
 * The per-collection `/api/<silo>msservices/actions` routes the options edit
 * used to take are retired by #1627 phase B.
 *
 * ⚠ The wire body is built HERE, not left to `httpPost`. The payload carries
 * client-only fields and `buildPostBody` would `JSON.stringify` it, dropping
 * the callback but happily serialising `__kind`. Stripping explicitly is
 * deterministic; relying on functions not being JSON is a coincidence.
 */
const apiEntityPath = '/api/transactions'

export async function writeCrossEntityActions(payload: IEntityActionsPayload) {
  const callingMn = writeCrossEntityActions.name
  return httpPost({
    callingMn,
    apiPath: apiEntityPath,
    entity: toEntityActionsWireBody(payload) as any,
    asyncOptions: { doAsync: true },
  })
}
